// extracted by mini-css-extract-plugin
export default {"subtitle__video":"SubtitleVideo_subtitle__video__PJ7gD","video__cast":"SubtitleVideo_video__cast__cewAy","cast":"SubtitleVideo_cast__5Ky-A"};